import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { remindersApi } from "./remindersApi";

// Shared "nuovo promemoria" form. `preset` = { text, ref_name, ref_email }.
export function ReminderDialog({ open, onClose, onCreated, preset }) {
  const [text, setText] = useState(preset?.text || "");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const MAX = 2000;

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim() || !date) { setErr("Scrivi il testo e scegli la data"); return; }
    if (text.trim().length > MAX) { setErr(`Testo troppo lungo: massimo ${MAX} caratteri`); return; }
    setErr("");
    setBusy(true);
    try {
      const r = await remindersApi.create({ text: text.trim(), due_date: date, due_time: time || null, ref_name: preset?.ref_name, ref_email: preset?.ref_email });
      toast.success("Promemoria salvato");
      onCreated?.(r);
      onClose();
    } catch (e) {
      const st = e?.response?.status;
      setErr(st === 401 ? "Sessione scaduta: ricarica la pagina e rientra" : st === 422 ? "Dati non validi (testo troppo lungo o data errata)" : "Errore nel salvataggio, riprova");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md bg-[#fdf8f1] border-[#e8dcc8]" data-testid="reminder-dialog">
        <DialogHeader><DialogTitle className="font-serif text-[#2b1410]">Nuovo promemoria</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Cosa devi ricordare? Es. Scade opzione Clizio di Valentina – riaprire camera o confermare caparra"
            className="w-full rounded-xl border border-[#e8dcc8] bg-white px-3 py-2 text-sm text-[#2b1410] focus:outline-none focus:ring-2 focus:ring-[#c5a059]" data-testid="reminder-text" />
          <div className={`text-[11px] text-right ${text.length > MAX ? "text-red-700 font-semibold" : "text-[#9a7f72]"}`} data-testid="reminder-counter">{text.length}/{MAX}</div>
          <div className="grid grid-cols-2 gap-2">
            <label className="text-xs text-[#7c5a4e]">Giorno
              <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1 w-full rounded-xl border border-[#e8dcc8] bg-white px-3 py-2 text-sm text-[#2b1410]" data-testid="reminder-date" />
            </label>
            <label className="text-xs text-[#7c5a4e]">Ora <span className="opacity-60">(vuoto = 9:00)</span>
              <input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="mt-1 w-full rounded-xl border border-[#e8dcc8] bg-white px-3 py-2 text-sm text-[#2b1410]" data-testid="reminder-time" />
            </label>
          </div>
          {err && <p className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="reminder-error">{err}</p>}
          <p className="text-[11px] text-[#9a7f72]">Quel giorno ricevi una notifica sul telefono e nella campanella; resta in evidenza finché non lo spunti come fatto.</p>
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} className="rounded-full px-4 py-2 text-sm text-[#7c5a4e] hover:bg-[#f7ebdf]" data-testid="reminder-cancel">Annulla</button>
            <button type="submit" disabled={busy} className="inline-flex items-center gap-1 rounded-full bg-[#4a1c17] text-[#f7ebdf] px-4 py-2 text-sm font-semibold hover:bg-[#2b1410] disabled:opacity-60" data-testid="reminder-save">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Salva
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
